<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <h1>Statistik Profilbauer</h1>
      </div>
    </div>
    <div class="row">
      <el-date-picker
        type="daterange"
        range-separator="bis"
        start-placeholder="Start"
        end-placeholder="Ende"
        value-format="yyyy-MM-dd hh:mm:ss"
        format="dd.MM.yyyy"
        v-model="date"
        @input="getStats()"
      >
      </el-date-picker>
    </div>
    <div v-for="(error, index) in errors" :key="index">
      <div v-for="(element, index) in error" :key="index" class="text-danger">
        {{ element }}
      </div>
    </div>
    <div v-if="stats" class="row">
      <div class="col">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Fakes erstellt</th>
              <th scope="col">davon Dynamisch</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(stat, index) in stats" :key="index">
              <td>{{ stat.name }}</td>
              <td>{{ stat.all_count }}</td>
              <td>{{ stat.dynamic_count }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else>
      <h5>Keine Daten vorhanden</h5>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { DatePicker } from "element-ui";

export default {
  components: {
    [DatePicker.name]: DatePicker
  },

  data() {
    return {
      stats: {},
      filter: null,
      date: [],
      errors: []
    };
  },

  methods: {
    getStats() {
      if (this.date) {
        axios
          .post("/api/v1/stats/profileBuilder", {
            from: this.date[0],
            to: this.date[1]
          })
          .then(response => {
            this.stats = {};
            this.stats = response.data;
          })
          .catch(error => {
            if (error.response) {
              this.errors = error.response.data.errors;
            }
          });
      } else {
        axios.post("/api/v1/stats/profileBuilder").then(response => {
          this.stats = {};
          this.stats = response.data;
        });
      }
    }
  },

  created() {
    axios.post("/api/v1/stats/profileBuilder").then(response => {
      this.stats = response.data;
    });
  }
};
</script>
<style lang="scss"></style>
